<template>
  <div class="search-wrap">
    <a href="#" class="search-icon icon-search" title="Search" @click.prevent="doSearch()"></a>
    <input
      type="text"
      name="keywords"
      :placeholder="placeholder"
      v-model="input"
      @keyup.enter="doSearch()"
      @keyup.esc="reset()"
    />
    <a v-if="hasInput" class="clear" href="#" @click.prevent="reset">
      <i class="icon icon-plus"></i>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: String, default: "" },
    placeholder: { type: String, default: "Search" }
  },
  data: function() {
    return {
      input: ""
    };
  },
  computed: {
    hasInput() {
      return `${this.input}`.length > 0;
    }
  },
  watch: {
    value(val) {
      this.input = val;
    },
    input(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    doSearch() {
      this.$emit("search");
    },
    reset() {
      this.input = "";
      this.$nextTick(() => {
        this.doSearch();
      });
    }
  },
  mounted() {
    this.input = this.value;
  }
};
</script>
